import styled, { createGlobalStyle } from 'styled-components';
import * as colors from '../config/colors';
import 'react-toastify/dist/ReactToastify.css';

export default createGlobalStyle`
   * {
      margin: 0;
      padding: 0;
      outline: none;
      box-sizing: border-box;
   }

   body {
      font-family: 'Noto Sans', sans-serif;
      background: ${colors.primaryDarkColor};
      color: ${colors.primaryDarkColor};
      padding: 0;
      min-width: 0;
   }

   #root {
      min-height: 100vh;
   }

   form {
      width: 100%;
   }

   /* Default de input/select do legado — rede de segurança, NÃO API.
      (Mesma natureza do default de <button>; ver FC7 §G.4.)

      O :where() é deliberado (2026-08-22). Escrito como
      input:not([type="checkbox"]), o seletor valia 0,0,1,1 — o :not() não
      soma especificidade, mas o [type="checkbox"] DENTRO dele soma. Isso
      vencia a classe de qualquer styled-component (0,0,1,0) e sobrescrevia
      silenciosamente height/padding de TODO input estilizado do app,
      inclusive os primitivos do kit em styles/ui/Form.js (que pedem 40px e
      apanhavam 36px) e qualquer campo de busca com ícone sobreposto (o
      padding-left: 4px anulava o recuo que abre espaço pro ícone).

      O :where() tem especificidade ZERO, então o seletor cai para 0,0,0,1
      (só o elemento). O que casa é idêntico e o legado sem estilo próprio
      continua recebendo 36px/4px — mas agora qualquer classe vence. */
   input:where(:not([type="checkbox"])),
   select {
      height: 36px;
      padding-left: 4px;
   }
   /* html, body, #root {
      height: 100%;
   } */

   .edit-button {
      background-color: ${colors.infoColor};
   }

   .edit-button:hover {
      background-color: ${colors.infoColorHover};
   }

   .alert-button {
      background-color: ${colors.errorColor};
   }

   .alert-button:hover {
      background-color: ${colors.errorColorHover};
   }

   /* Default de <button> cru (legado) — FC7: mantém o contrato "sólido +
      texto branco" e a geometria antiga (sem reflow); só o hue muda para o
      azul-escrita. Código novo usa o kit de styles/ui/Button.js. */
   button {
      cursor: pointer;
      background-color: ${colors.actionWriteColor};
      border: none;
      color: white;
      padding: 8px;
      border-radius: 4px;
      font-weight: bold;
      font-family: inherit;
   }

   textarea {
      resize: none;
      text-transform: uppercase;
   }

   button:hover {
      background-color: ${colors.actionWriteColorHover};
   }

   button:disabled {
      background-color: ${colors.lightGrayColor};
      color: #fff;
      cursor: not-allowed;
   }

   a {
      text-decoration: none;
      color: ${colors.linkColor};
      font-weight: 600;
      transition: 0.1s;
   }

   a:hover {
      color: ${colors.linkColorHover};
      text-decoration: underline;
   }

   ul {
      list-style: none;
   }

   /* ===== Toast (react-toastify) alinhado ao DS ===== */
   :root {
      --toastify-font-family: 'Noto Sans', sans-serif;
      --toastify-color-info: ${colors.primaryColor}; /* azul = info */
      --toastify-color-success: #1f9d55; /* verde = sucesso (colors.sucessColor é azul) */
      --toastify-color-warning: ${colors.warningColor};
      --toastify-color-error: ${colors.errorColor};
      --toastify-text-color-light: ${colors.primaryDarkColor};
      --toastify-toast-bd-radius: 8px;
   }

   .Toastify__toast {
      border-radius: 8px;
      box-shadow: 0 6px 24px rgba(0, 0, 0, 0.16);
      padding: 12px 14px;
   }

   .Toastify__toast-body {
      font-size: 0.9rem;
      line-height: 1.35;
      color: ${colors.primaryDarkColor};
   }

   .Toastify__close-button {
      align-self: center;
      color: ${colors.primaryDarkColor};
      opacity: 0.5;
   }
   .Toastify__close-button:hover {
      opacity: 1;
   }

   .Toastify__progress-bar {
      height: 3px;
   }

   /* ===================================================================
      IMPRESSÃO (semente do capítulo de impressão do FC7) — 2026-09-13
      ===================================================================
      Nasceu com o comprovante de movimento (pages/MovementReceipt), a
      primeira tela do app que imprime de verdade, e é global de propósito:
      qualquer documento futuro herda a mesma base.

      Contrato: quem quer ir para o papel marca o container com o atributo
      data-print-root. Tudo o mais — sidebar, topbar, barras de ação, toasts,
      a barra de ferramentas da própria pré-visualização — sai.

      A técnica é visibility e não display:none no ancestral: esconder o
      ancestral por display apagaria o descendente junto. Com visibility, o
      filho marcado volta a ficar visível e é reposicionado para a origem da
      folha.

      ⚠️ O cabeçalho/rodapé do NAVEGADOR (URL, data, "1/1") não é alcançável
      por CSS — é preferência do diálogo de impressão, desmarcada uma vez em
      "Cabeçalhos e rodapés" e lembrada por origem. É o único item do
      checklist de aceite do design que o front não controla.

      Sobre o !important daqui: o FC7 §G.6 proíbe usá-lo para brigar com este
      arquivo a partir de um componente. Este é o caso inverso e o legítimo —
      um reset de MÍDIA, dentro do próprio GlobalStyles, que precisa vencer o
      fundo/geometria que qualquer styled-component tenha declarado para a
      tela. Não há estado a declarar no lugar dele.

      (Sem backticks neste comentário de propósito: ele vive DENTRO de um
      template literal, e um backtick fecharia a string.) */
   @media print {
      html,
      body,
      #root {
         background: #fff !important;
         min-height: 0;
      }

      /* O shell colapsa: sem grid de 2 colunas, sem min-height de 100vh.
         Sem isto, o 100vh do Shell e da sidebar reserva uma folha inteira e
         sai uma página em branco depois do documento. */
      [data-app-shell] {
         display: block !important;
         min-height: 0 !important;
      }

      body * {
         visibility: hidden;
      }

      [data-print-root],
      [data-print-root] * {
         visibility: visible;

         /* ⚠️ SEM ISTO O DOCUMENTO SAI SEM FUNDO. O navegador imprime em
            modo "economia de tinta" por default: descarta background-color
            e, para o texto branco não ficar invisível sobre o branco do
            papel, ele AINDA escurece esse texto — o resultado é a faixa de
            identidade e o cabeçalho da tabela saindo em cinza claro, sem
            barra escura nenhuma (defeito real, visto no primeiro smoke).

            print-color-adjust: exact é o opt-in que manda pintar o que foi
            declarado; vale mesmo com "Gráficos de segundo plano" desmarcado
            no diálogo. O prefixo -webkit continua necessário no Chrome. */
         -webkit-print-color-adjust: exact;
         print-color-adjust: exact;
      }

      [data-print-root] {
         position: absolute;
         top: 0;
         left: 0;
         width: 100%;
         margin: 0;
         padding: 0;
      }

      /* Fora do papel em qualquer tela: controles da pré-visualização e
         qualquer coisa deliberadamente marcada como só-tela. */
      [data-print-hide] {
         display: none !important;
      }

      .Toastify {
         display: none !important;
      }

      /* Tabela longa: cabeçalho repete a cada página e linha não se parte. */
      thead {
         display: table-header-group;
      }
      tfoot {
         display: table-footer-group;
      }
      tr,
      img {
         page-break-inside: avoid;
      }
   }
`;

export const Container = styled.section`
   height: auto;
   width: 60vw;
   min-width: 680px;
   background: #fff;
   margin: 30px auto;
   padding: 32px;
   border-radius: 4px;
   display: flex;
   flex-direction: column;
   align-items: center;

   h3 {
      text-align: left;
      width: 100%;
      margin-bottom: 24px;
   }

   .p-left-align {
      text-align: left;
      width: 100%;
      margin-bottom: 24px;
   }

   @media (max-width: 900px) {
      width: calc(100% - 24px);
      min-width: 0;
      margin: 12px auto;
      padding: 16px;
   }

`;

export const TableHeader = styled.div`
   margin-top: 24px;
   background-color: ${colors.primaryColor};
   color: white;
   text-align: center;
   padding: 8px 0;
   border-radius: 8px 8px 0 0;
   width: 100%;
`;

export const TableFooter = styled.div`
   background-color: ${colors.primaryColor};
   color: white;
   text-align: center;
   padding: 8px 0;
   border-radius: 0 0 8px 8px;
   width: 100%;
`;

export const TableData = styled.div`
   width: 100%;
   overflow-x: auto;
   border: 1px solid ${colors.primaryColor};

   table {
      width: 100%;
      border-spacing: 0;
   }

   tr {
      height: 8px;
      cursor: pointer;
   }

   th {
      border-collapse: collapse;
      background-color: ${colors.primaryDarkColor};
      color: #fff;
      padding: 8px 4px;
   }

   td {
      border-collapse: collapse;
      border: 1px solid ${colors.lightGrayColor};
      padding: 4px 16px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      max-width: 360px;
      font-size: 0.9em;
   }

   tr:hover {
      color: ${colors.primaryColor};
   }

   .th-major-w {
      width: 360px;
   }
   .td-small-w {
      text-align: center;
      width: 80px;
   }
   .th-extralarge-w {
      width: 480px;
   }
   .td-medium-w {
      width: 240px;
   }
`;

export const TrEnabledAction = styled.tr`
   &:hover {
      background-color: ${colors.primaryColorLight};
      cursor: pointer;

      td {
         color: ${colors.primaryDarkColor};
      }
   }
`;

export const TrDisabledAction = styled.tr`
   &:hover {
      background-color: ${colors.lightBgText};
      cursor: pointer;

      td {
         color: ${colors.primaryDarkColor};
         cursor: text;
      }
   }
`;

// Estilos para produtos
export const ProductLargeFields = styled.div`
   display: flex;
   flex-direction: column;
   row-gap: 24px;
   border: 1px solid ${colors.lightBgText};
   border-radius: 8px;
   width: 100%;
   padding: 24px;
   margin-bottom: 24px;

   input,
   select {
      font-size: 1.1em;
   }

   label {
      font-size: 0.8em;
      margin-bottom: 4px;
   }

   &:focus-within {
      border: 1px solid ${colors.primaryColor};
   }

   input:focus-within:not(:read-only) {
      border: 2px solid ${colors.primaryColor};
   }

   select {
      border: 1px solid ${colors.lightGrayColor};
      border-radius: 4px;
   }

   .row-fields {
      display: flex;
      width: 100%;
      column-gap: 24px;
      justify-content: space-between;
      align-items: center;
   }

   .fields {
      display: flex;
      flex-direction: column;
      width: 20%;
   }

   .fields-30 {
      width: 30%;
      display: flex;
      flex-direction: column;
   }
   .fields-large {
      display: flex;
      flex-direction: column;
      width: 60%;
   }
   .fields-medium {
      display: flex;
      flex-direction: column;
      width: 50%;
   }
`;

export const ProductSmallFields = styled.div`
   display: flex;
   flex-direction: column;
   row-gap: 24px;
   border: 1px solid ${colors.lightBgText};
   border-radius: 8px;
   width: 100%;
   padding: 24px;

   &:focus-within {
      border: 1px solid ${colors.primaryColor};
   }

   h3 {
      text-align: left;
   }

   input {
      width: 80px;
      text-align: right;
      padding: 8px;
      font-size: 1.1em;
   }

   label {
      font-size: 0.8em;
      margin-bottom: 4px;
   }

   div {
      display: flex;
      flex-direction: row;
      justify-content: center;
      column-gap: 24px;
   }

   .input-replica {
      border: 1px solid ${colors.lightGrayColor};
      width: 120px;
      height: 36px;
      border-radius: 4px;
      align-items: center;
      justify-content: space-around;
      column-gap: 0;

      p {
         color: ${colors.lightGrayColor};
      }

      input {
         background-color: #fff;
         border: none;
         width: 70%;
         height: 100%;
      }
   }

   .input-replica:focus-within {
      border: 2px solid ${colors.primaryColor};
   }

   .small-fields {
      display: flex;
      justify-content: start;
      flex-direction: row;
   }

   .fields {
      display: flex;
      flex-direction: column;
   }

   .date-field {
      display: flex;
      flex-direction: column;
      width: 100px;
   }
`;

// TEXT STYLES

export const Title = styled.h1`
   text-align: left;
   width: 100%;
   margin-bottom: 24px;
`;

